// @ts-nocheck

import withStyles from "@material-ui/core/styles/withStyles";
import { Component } from "react";
import { InputText } from "../Form";
import Maps from "../Maps/Maps";

import { GridContainer, GridItem } from "../Grid";

// Style
const styles = {};

class InputMap extends Component {
  onChange = ({ event, latLng, pixel }) => {
    this.props.onChange(this.props.name, {
      latitude: `${parseFloat(latLng[0].toFixed(6))}`,
      longitude: `${parseFloat(latLng[1].toFixed(6))}`,
    });
  };

  onChangeInputText = ({ target }) => {
    const { name, value } = target;

    this.props.onChange(this.props.name, {
      latitude: this.props.latitude,
      longitude: this.props.longitude,
      [name]: value,
    });
  };

  render() {
    const { latitude, longitude, } = this.props;
    const floatLatitude = parseFloat(latitude);
    const floatLongitude = parseFloat(longitude);
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Maps
            latitude={floatLatitude || 0}
            longitude={floatLongitude || 0}
            zoom={14}
            height={400}
            onChange={this.onChange}
            markers={[
              {
                latitude: floatLatitude,
                longitude: floatLongitude,
              },
            ]}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(InputMap);
